/* eslint-disable camelcase */
import get from 'lodash/get';
import messages from '../../../../messages';
import { facetArrayToObject } from './facets';
import { getFiltersValuesHomes } from './getFiltersValuesHomes';
import { getFiltersValuesCars } from './getFiltersValuesCars';
import { getFiltersValuesJobs } from './getFiltersValuesJobs';
import { getFiltersValuesProducts } from './getFiltersValuesProducts';

const { filtersDay, filtersWeek, filtersAny } = messages;

export const getFiltersValues = (facets, searchParameters, intl, config) => {
  const verticalName = config.verticalName;
  const filtersConf = get(config, ['vertical', 'filters']);
  const searchParametersFilters = get(searchParameters, 'filters');
  const type_id = get(searchParameters, 'type_id');
  const country = {
    code: config.countryCode,
    readingDirection: get(config, ['vertical', 'readingDirection']),
  };

  let filters = {
    date_from: {
      '0': intl.formatMessage(filtersAny),
      '1': intl.formatMessage(filtersDay),
      '7': intl.formatMessage(filtersWeek),
    },
    region: facetArrayToObject(facets.fa_region),
    city: facetArrayToObject(facets.fa_city),
    city_area: facetArrayToObject(facets.fa_city_area),
  };

  switch (verticalName) {
    case 'homes':
      filters = getFiltersValuesHomes(
        filters,
        searchParametersFilters,
        filtersConf,
        type_id,
        facets,
        country,
        intl
      );
      break;
    case 'cars':
      filters = getFiltersValuesCars(
        filters,
        searchParametersFilters,
        filtersConf,
        facets,
        country,
        intl
      );
      break;
    case 'jobs':
      filters = getFiltersValuesJobs(filters, filtersConf, facets, country, intl);
      break;
    case 'products':
      filters = getFiltersValuesProducts(
        filters,
        searchParametersFilters,
        filtersConf,
        type_id,
        facets,
        country,
        intl
      );
      break;
    default:
      break;
  }
  return filters;
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/getFiltersValues.js